import { WEBSHEET_TAGS } from '@whistler-ui/k2/constants';
import { getUserFacingErrorMessage } from '@whistler-ui/k2/helpers/userFacingError';

//Helper to help with error messages
//errorMessage =
// "No test data defined for DEPROVISION_VOLTE DEACTIVATE_VOLTE_FAIL" returned is translated to
// "No test data defined for Deprovision VoLTE API on Deactivate VoLTE Fail Test Case"
//
export const errorMessageFormatting = (t, error) => {
  const errorMessage = error?.message ?? '';

  if (
    errorMessage.includes(WEBSHEET_TAGS.WS_ESIM_QUICK_TRANSFER) &&
    errorMessage.includes('Localisation')
  ) {
    return t('errorMessage_missing_localization');
  }

  if (
    errorMessage.includes(t('errorMessage_formatting_no_test_data_defined'))
  ) {
    const words = errorMessage
      .replace(t('errorMessage_formatting_no_test_data_defined'), '')
      .replaceAll('"', '');
    const wordsList = words.split(' ');
    const translatedSentence = t(
      'errorMessage_formatting_no_test_data_defined',
    );

    return (
      translatedSentence +
      t(wordsList[0]) +
      t('errorMessage_formatting_API_on') +
      t(wordsList[1]) +
      t('errorMessage_formatting_test_case')
    );
  }

  if (
    errorMessage.includes(
      t('errorMessage_formatting_use_case_no_test_data_defined'),
    )
  ) {
    return t('errorMessage_formatting_use_case_no_test_data_defined');
  }

  return getUserFacingErrorMessage(error, t('common:errors.default'));
};

//helper for hasError
export const hasError = (name, touched, errors, dirty) =>
  dirty && touched[name] && errors[name] !== undefined;
